import ModalStack from '@/components/Custom/ModalStack';

export default function PrivateEventEventIdEventsShareLayoutRoute() {
  return <ModalStack />;
}
